import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@volca/ui/components/ui/select";
import { dayjs } from "@/core/utils/date";
import {
  PAY_PERIOD_DAYS,
  payPeriodStart,
} from "@/profitability/new-run/run-period";

const ISO = "YYYY-MM-DD";

/** The latest day the week starts on, on or before today: a likely pay period start. */
export const defaultPayPeriodAnchor = (weekStartsOn: number) => {
  const today = dayjs().startOf("day");
  return today
    .subtract((today.day() - weekStartsOn + 7) % 7, "day")
    .format(ISO);
};

/**
 * Which day a pay period starts on, picked from the last 14 days: every
 * possible two-week cycle starts on exactly one of them, so no calendar is
 * needed. A saved anchor shows as its day within that window.
 */
export const PayPeriodStartSelect = ({
  anchor,
  weekStartsOn,
  labelledBy,
  onChange,
}: {
  anchor: string | null;
  weekStartsOn: number;
  labelledBy: string;
  onChange: (anchor: string) => void;
}) => {
  const today = dayjs().startOf("day");
  const days = Array.from({ length: PAY_PERIOD_DAYS }, (_, index) =>
    today.subtract(PAY_PERIOD_DAYS - 1 - index, "day"),
  ).reverse();
  const items = Object.fromEntries(
    days.map((day) => [day.format(ISO), day.format("ddd, MMM D")]),
  );
  const value = payPeriodStart(
    anchor ?? defaultPayPeriodAnchor(weekStartsOn),
    today,
  ).format(ISO);
  return (
    <Select
      value={value}
      items={items}
      onValueChange={(next) => next && onChange(String(next))}
    >
      <SelectTrigger aria-labelledby={labelledBy}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="pointer-coarse:[&_[data-slot=select-item]]:min-h-11">
        {Object.entries(items).map(([day, label]) => (
          <SelectItem key={day} value={day}>
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
